var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useState } from 'react';
import { ethers } from 'ethers';
import { getProtocolContract } from '@sovryn/contracts';
import { defaultChainId } from '../config/chains';
import { useAccount } from './useAccount';
export const useGetProtocolContract = (contractName, chain = defaultChainId, customSigner) => {
    const { signer: userSigner } = useAccount();
    const [address, setAddress] = useState(undefined);
    const [abi, setAbi] = useState(undefined);
    const getContractDetails = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield getProtocolContract(contractName, chain);
        return result;
    }), [chain, contractName]);
    const contract = useMemo(() => {
        getContractDetails().then(result => {
            setAddress(result.address);
            setAbi(result.abi);
        });
        if (address && abi) {
            const signer = customSigner || userSigner;
            return new ethers.Contract(address, abi, signer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getContractDetails, address, abi]);
    return contract;
};
